import { TESTIMONIALS, ABOUT } from "@/data/content";
import SectionHeader from "@/components/common/SectionHeader";
import { Quote } from "lucide-react";
import { getImageUrl } from "@/lib/api";

export default function Testimonials() {
  return (
    <section className="section-y bg-[var(--bg)]" data-testid="home-testimonials">
      <div className="container-sf">
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <div>
            <SectionHeader
              eyebrow="Suara Komunitas"
              title="Cerita mereka yang"
              accentTitle="bersama kami"
              description="Bukan sekadar statistik. Ini adalah kisah nyata dari masyarakat yang menjalani transformasi bersama Sauyunan Foundation."
            />
            {/* Values grid */}
            <div className="grid grid-cols-2 gap-3 mt-6">
              {ABOUT.values.slice(0, 4).map((v) => (
                <div key={v.key} className="rounded-xl border border-slate-200 bg-white px-4 py-3">
                  <div className="text-xs font-bold text-[var(--brand-orange)] uppercase tracking-wider">{v.title}</div>
                  <div className="mt-1 text-xs text-slate-600 leading-tight">{v.body.split(" ").slice(0, 6).join(" ")}...</div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-5">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                className={`card-sf p-7 relative ${i === 1 ? "md:ml-8" : ""}`}
                data-testid={`testimonial-${i}`}
              >
                <Quote className="absolute top-6 right-6 h-8 w-8 text-[var(--brand-orange)]/20" />
                <p className="text-slate-700 leading-relaxed text-[15px] md:text-base font-serif-display italic">
                  "{t.quote}"
                </p>
                <div className="mt-5 flex items-center gap-3">
                  <img src={getImageUrl(t.avatar)} alt={t.name} className="h-11 w-11 rounded-full object-cover" />
                  <div>
                    <div className="font-semibold text-slate-900 text-sm">{t.name}</div>
                    <div className="text-xs text-slate-500">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
